import ManagedStaticPage from '../components/ManagedStaticPage';

export default function About() {
  return <ManagedStaticPage slug="about" fallbackTitle="About" />;
}

